//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import {Link} from 'react-router-dom'
//@end

//@import components
import AllEventsModuleSkeleton from 'app_components/modules/newsEvents/allevents/components/alleventsModuleSkeleton';
import NewsCardComponent from 'app_components/commons/newsCard'
import TagsCommon from 'app_components/commons/tags'
import AlertComponent from 'app_components/commons/alert/containers/alertComponent';
import PaginationComponent from 'app_components/commons/pagination'
//@end

// @import hooks
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
// @end

// @INFO Import services
import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../alleventsModule.scss'

// @ADD Component types
interface IAlleventsModuleLayoutProps {
  tags: Array<any>
  posts: Array<any>
	loading: boolean
  pagination: IPagination
  onPageChange?: (page: number) => void
  onChangeTag?: (tag: any) => void
}

const AlleventsModuleLayout: React.FC<IAlleventsModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className={'all-events'}>
      {/* {props.tags && props.tags.length > 0 && (
        <TagsCommon tags={props.tags} limit={4} onClick={props.onChangeTag}/>
      )} */}
      {props.loading ? (
        <AllEventsModuleSkeleton />
      ) : (
        <>
          {props.posts && props.posts.length > 0 ? (
            <>
              <div className={'row'}>
                {props.posts.map((n) => (
                    <div className={`item col-md-3 mb-4`} key={n.key}>
                      <Link to={routingService.getPublicPath(`/evento/${n.slug}`)}>
                        <NewsCardComponent {...n} />
                      </Link>
                    </div>
                  ))
                }
              </div>
              {props.pagination && (
                <div className="row">
                  <div className="col-12">
                    <PaginationComponent data={props.pagination} onChangePage={props.onPageChange} />
                  </div>
                </div>
              )}
            </>
          ) : (
            <div>
              <AlertComponent
                type='warning'
                title={t('modules.events.no_data')}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default AlleventsModuleLayout
